import types from '@/vuex/tramitacoes/mutations-types'

const mutations = {
  [types.SET_LISTA_TRAMITACOES]: (state, payload) => {
    state.listaTramitacoes = payload.listaTramitacoes
  },
  [types.SET_LISTA_FLUXOS]: (state, payload) => {
    state.listaFluxos = payload.listaFluxos
  },
  [types.SET_DESTINOS_FLUXO]: (state, payload) => {
    state.listaDestinosFluxo = payload.listaDestinosFluxo
  },
  [types.SET_VALIDACAO_FLUXO]: (state, payload) => {
    state.listaValidacaoFluxo = payload.listaValidacaoFluxo
  },
  [types.SET_FLUXO]: (state, payload) => {
    state.fluxoSelecionado = payload.fluxoSelecionado
  },
  [types.SET_DESTINO]: (state, payload) => {
    state.destinoSelecionado = payload.destinoSelecionado
  },
  [types.SET_DESPACHO]: (state, payload) => {
    state.despachoSelecionado = payload.despachoSelecionado
  },
  [types.SET_DESPACHO_SALVO]: (state, payload) => {
    state.despachoSalvo = payload.despachoSalvo
  },
  [types.SET_NIVEL_ACESSO]: (state, payload) => {
    state.nivelAcessoSelecionado = payload.nivelAcessoSelecionado
  },
  [types.SET_LISTA_HIPOTESE_LEGAL]: (state, payload) => {
    state.listaHipotesesLegais = payload.listaHipotesesLegais
  },
  [types.SET_HIPOTESE_LEGAL]: (state, payload) => {
    state.hipoteseLegalSelecionada = payload.hipoteseLegalSelecionada
  },
  [types.SET_TIPO_DESPACHO]: (state, payload) => {
    state.tipoDespachoSelecionado = payload.tipoDespachoSelecionado
  },
  [types.SET_DESPACHO_PREPARATORIO]: (state, payload) => {
    state.despachoPreparatorio = payload.despachoPreparatorio
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/tramitacoes/mutations.js